import personReducer from "./reducers";
export { default as personTypes } from './types'
export { default as personActions } from './actions'

export default personReducer